import { Box, Container, Typography } from "@mui/material";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

export default function About() {
  useDocumentMetaData({
    title: "About Midwest Group",
    description:
      "Learn about the Midwest Group, part of Thermal Systems, with over 35 years of experience in walls, ceilings, and construction innovation across North America.",
    keywords:
      "about Midwest Group, roofing experts, wall and ceiling specialists, construction subcontractor, Thermal Systems company, Midwest construction history",
    canonical: "https://www.midwest-group.com/about",
    author: "Midwest Group",
    ogTitle: "About Midwest Group",
    ogDescription:
      "Discover the Midwest Group, a leader in walls and ceilings for over 35 years, now part of Thermal Systems.",
    ogImage:
      "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png",
    ogUrl: "https://www.midwest-group.com/about",
    twitterTitle: "About Midwest Group - Leaders in Walls & Ceilings",
    twitterDescription:
      "Get to know the Midwest Group, a construction industry leader for over 35 years, specializing in walls and ceilings.",
    twitterImage:
      "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png",
  });

  return (
    <>
      <Container
        sx={{
          minHeight: "63vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flex: "1", paddingTop: 15 }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h2"
              component="h2"
              style={{ fontWeight: "600" }}
              gutterBottom
              className="Main-content"
            >
              About MidWest
            </Typography>
          </Box>
          <p className="aboutparagraph">
            The MidWest Group, now part of the Thermal Systems group of
            companies, has over 35 years of experience in the construction
            industry.
            <br /> We are considered leaders, specializing in walls and
            ceilings, with a goal of being the best subcontractor on site every
            time.
            <br /> We are revolutionizing the industry through inspired people
            pushing the use of the latest technology for the purpose of reducing
            the life cycle costs of your ceiling and wall systems.
          </p>
        </Box>
      </Container>
    </>
  );
}
